module.exports = __webpack_public_path__ + "images/emoji/dancers.385f687da5fc6d24a7a4.png";